import { css } from 'aphrodite';
import axios from 'axios';
import * as React from 'react';
import { NavLink, RouteComponentProps } from 'react-router-dom';
import gmail from '../../assets/gmail_logo.png';
import hawksoft from '../../assets/hawksoft_logo.png';
import iHouseWeb from '../../assets/ihouse_web_logo.png';
import loopnet from '../../assets/loopnet_logo.png';
import office365 from '../../assets/office365_logo.png';
import opcity from '../../assets/opcity_logo.png';
import outlook from '../../assets/outlook_logo.png';
import realtorDotCom from '../../assets/realtor_logo.png';
import referralExchange from '../../assets/referral_exchange_logo.png';
import spacio from '../../assets/spacio_logo.png';
import display from '../../assets/web_mobile_display.png';
import zillow from '../../assets/zillow_logo.png';
import { CheckMarkIcon } from '../../components/icons/CheckMarkIcon';
import { QuoteIcon } from '../../components/icons/QuoteIcon';
import { SvgIcon } from '../../components/icons/SvgIcon';
import { TextInputWithLabel } from '../../components/TextInputWithLabel';
import { parseUtmSource } from '../../models';
import { logPageView } from '../../models/Analytics';
import { styleSheet } from './styles';

// tslint:disable: max-line-length
interface IProps extends RouteComponentProps<any> {
	className?: string;
}

interface IState {
	companyValue?: string;
	demoRequested?: string;
	emailValue?: string;
	firstNameValue?: string;
	lastNameValue?: string;
	phoneNumberValue?: string;
	utmSource?: string;
}

export class Trial extends React.Component<IProps, IState> {
	public state: IState = {
		companyValue: '',
		demoRequested: '',
		emailValue: '',
		firstNameValue: '',
		lastNameValue: '',
		phoneNumberValue: '',
	};

	public componentDidMount() {
		window.scrollTo(0, 0);
		document.title = 'Levitate - Trial';

		const utmSource = parseUtmSource('facebook');
		logPageView('Trial:' + utmSource);
		this.setState({ utmSource });
	}

	public render() {
		const { firstNameValue, lastNameValue, emailValue, companyValue, phoneNumberValue, demoRequested } = this.state;

		return (
			<div className={ css(styleSheet.trialContainer) }>
				<div className={ css(styleSheet.backgroundBlue) }>
					<svg viewBox='0 0 1200 710' fill='none' xmlns='http://www.w3.org/2000/svg' className={ css(styleSheet.bgSVG) } preserveAspectRatio='none'>
						<path fillRule='evenodd' clipRule='evenodd' d='M0 0h1200v557L0 710V0z' fill='url(#paint0_linear)' />
						<mask id='a' maskUnits='userSpaceOnUse' x='0' y='0'>
							<path fillRule='evenodd' clipRule='evenodd' d='M0 0h1200v557L0 710V0z' fill='#fff' />
						</mask>
						<defs>
							<linearGradient id='paint0_linear' x1='368.641' y1='-3.076' x2='365' y2='270.788' gradientUnits='userSpaceOnUse'>
								<stop stopColor='#046CB6' />
								<stop offset='1' stopColor='#00528C' />
							</linearGradient>
						</defs>
					</svg>
				</div>
				<div className={ css(styleSheet.trialContentContainer) }>
					<header className={ css(styleSheet.logoContainer) }>
						<NavLink to='/'>
							<SvgIcon className={ css(styleSheet.logoSVG) } width='320' height='60' fill='none' xmlns='http://www.w3.org/2000/svg'>
								<path fillRule='evenodd' clipRule='evenodd' d='M143.402.333V59h1.651V2.016h45.155V3.84H152.07v5.19h39.797V7.344H153.72V5.522h38.139V.333h-48.457zm-2.987 0v56.983h-2.197V.335h-20.844l-13.554 41.5L90.267.334h-5.82l17.412 52.789h3.817l15.89-47.641h2.613L106.31 56.825h-5.334L82.157.335h-43.65l.024 55.082h1.66V6.463l-.018-4.444h40.793l18.818 56.49h7.701l19.04-54.71h-6.149L104.485 51.44h-1.431L86.753 2.02h2.316l14.751 45.167L118.573 2.02h17.985V59h5.517V.333h-1.66z' fill='#fff' />
								<path fillRule='evenodd' clipRule='evenodd' d='M0 .333V59h69.658v-5.132H43.565V5.638h24.49v1.88h-22.18v18.047H67.01v1.816H45.876V51.89h23.763v-1.689h-22.11V29.07h21.137v-5.193H47.53V9.207h22.18V3.948H41.912v51.608h26.093v1.754H1.654V2.022h1.964v53.535h24.703v-5.356H8.993V.34H7.34v51.55h19.328v1.978H5.272V.333H0zm231.701 47.334h-28.547l.599-1.69h25.462l-11.659-30.47-10.27 26.786h17.975l.658 1.69h-21.118L217.556 11l14.145 36.667zM241.667.333v5.234h38.577v1.84H241.66v1.697h40.254V3.87h-38.577V2.03h74.942v1.763h-26.338v51.873H320v-5.284h-22.389v-19.95h21.335v-5.22h-21.335V9.178h22.317V7.48h-23.987v19.43h21.336v1.824h-21.336V52.08h22.389v1.89h-24.72V5.491h26.339V.333h-78.282z' fill='#fff' />
								<path fillRule='evenodd' clipRule='evenodd' d='M212.523.333l-22.221 56.815h-12.927v-43.19h-5.537v43.19h-2.205V13.945h-1.666v44.896h5.537v-43.19h2.205v43.19h15.723l22.221-56.814h6.719l20.285 50.876h-2.527L219.685 5.187h-5.272L193.611 59h6.152l2.693-7.098h28.817l2.634 6.944 21.9-.005h9.089V13.96h-5.537v39.58h-2.205V13.946h-1.666v41.289h5.538V15.652h2.204v41.496h-20.794v.003l-7.386.001-2.634-6.942h-31.103l-2.693 7.096h-2.564L215.549 6.88h3.001l18.444 47.716h6.136L221.494.333h-8.971zm75.635 4v49.17l-.025 6.164H320v-1.692h-30.182l.018-53.642h-1.678z' fill='#fff' />
							</SvgIcon>
						</NavLink>
					</header>
					<main>
						<h1 className={ css(styleSheet.title) }>Grow your business through the lost art of keeping in touch.</h1>
						<h3 className={ css(styleSheet.subTitle) }>Can't keep up with personal outreach to your clients and prospects but tired of old school email marketing? We've got a solution.</h3>
						<section className={ css(styleSheet.displaySection) }>
							<div className={ css(styleSheet.displaySectionLeft) }>
								<img src={ display } alt='Levitate web and mobile app profile screens' className={ css(styleSheet.webMobileDisplay) } />
								<div className={ css(styleSheet.useCaseSection) }>
									<h4 className={ css(styleSheet.displayTitle) }>See how businesses use Levitate to:</h4>
									<ul>
										<li className={ css(styleSheet.useCaseItem) }>
											<CheckMarkIcon />
											<p className={ css(styleSheet.useCaseText) }>Drive referrals and reviews by keeping in touch with clients and prospects</p>
										</li>
										<li className={ css(styleSheet.useCaseItem) }>
											<CheckMarkIcon />
											<p className={ css(styleSheet.useCaseText) }>Cross-sell products and services through personalized emails</p>
										</li>
										<li className={ css(styleSheet.useCaseItem) }>
											<CheckMarkIcon />
											<p className={ css(styleSheet.useCaseText) }>Remember key facts about every contact (never forget a birthday again!)</p>
										</li>
										<li className={ css(styleSheet.useCaseItem) }>
											<CheckMarkIcon />
											<p className={ css(styleSheet.useCaseText) }>Access tried-and-tested, industry-specific email templates to save time and money</p>
										</li>
									</ul>
								</div>
							</div>
							<div className={ css(styleSheet.displaySectionRight) }>
								<div className={ css(styleSheet.signUp) }>
									<div className={ css(styleSheet.orangeBar) } />
									<div className={ css(styleSheet.signUpContentContainer) }>
										<h5 className={ css(styleSheet.signUpTitle) }>Sign up for a FREE guided tour of Levitate:</h5>
										<TextInputWithLabel
											label='First Name'
											value={ firstNameValue }
											onChange={ this.onChangeFirstName }
										/>
										<TextInputWithLabel
											label='Last Name'
											value={ lastNameValue }
											onChange={ this.onChangeLastName }
										/>
										<TextInputWithLabel
											label='Company'
											value={ companyValue }
											onChange={ this.onChangeCompany }
										/>
										<TextInputWithLabel
											label='Email'
											value={ emailValue }
											onChange={ this.onChangeEmail }
										/>
										<TextInputWithLabel
											label='Phone Number'
											required={ false }
											value={ phoneNumberValue }
											onChange={ this.onChangePhoneNumber }
										/>
										{
											demoRequested === 'success' ?
												<button className={ css(styleSheet.requestAnswer) }>
													<span className={ css(styleSheet.buttonSuccessText) }>{ demoRequested }</span>
													<CheckMarkIcon />
												</button>
												:
												<button className={ css(styleSheet.requestButton) } onClick={ this.onSubmitForDemo }>Request Demo</button>
										}
									</div>
								</div>
								<p className={ css(styleSheet.termsAgreement) }>By submitting this form, you are confirming you have read and agree to our <NavLink to='/terms'>Terms</NavLink> and <NavLink to='/privacy'>Privacy Statement</NavLink></p>
							</div>
						</section>
						<section className={ css(styleSheet.testimonialSection) }>
							<div className={ css(styleSheet.testimonialContainer) }>

								<h3 className={ css(styleSheet.testimonialTitle) }>What Our Customers Are Saying</h3>

								<div className={ css(styleSheet.testimonial) }>
									<QuoteIcon size={ 40 } largeQuote={ true } />
									<div className={ css(styleSheet.testimonialContent) }>
										<h5 className={ css(styleSheet.largeQuote) }>Levitate helps us focus on what's important to our business - relationships.</h5>
										<p className={ css(styleSheet.name) }>Mike Lotterhos</p>
										<p className={ css(styleSheet.name) }>CFO, Davis Moore Commercial Real Estate</p>
									</div>
									<QuoteIcon closeQuote={ true } size={ 40 } largeQuote={ true } />
								</div>

								<div className={ css(styleSheet.testimonial) }>
									<QuoteIcon size={ 40 } />
									<div className={ css(styleSheet.testimonialContent) }>
										<h6 className={ css(styleSheet.smallQuote) }>The first week I used the application I contacted 300+ customers and immediately received submissions for new business. The entire process took less than 15 minutes. I have made this a regular part of my weekly routine and continue to grow relationships that I otherwise would have let fall through the cracks.</h6>
										<p className={ css(styleSheet.name) }>John Archer</p>
										<p className={ css(styleSheet.name) }>CPRO Associates</p>
									</div>
									<QuoteIcon size={ 40 } closeQuote={ true } />
								</div>

								<div className={ css(styleSheet.testimonial) }>
									<QuoteIcon size={ 40 } />
									<div className={ css(styleSheet.testimonialContent) }>
										<h6 className={ css(styleSheet.smallQuote) }>I recently sent a personal email to a few hundred clients and prospects with Levitate just to wish them a Merry Christmas. Within days, I had a ton of replies and new policies to quote — enough to keep me busy for a whole month.</h6>
										<p className={ css(styleSheet.name) }>Brent Lamm</p>
										<p className={ css(styleSheet.name) }>Lamm Insurance Group</p>
									</div>
									<QuoteIcon size={ 40 } closeQuote={ true } />
								</div>
							</div>

						</section>
						<section className={ css(styleSheet.integrationSection) }>
							<h3 className={ css(styleSheet.integrationTitle) }>Integrations</h3>
							<div className={ css(styleSheet.integrationContainer) }>
								<img src={ office365 } alt='Office365 logo' className={ css(styleSheet.integration) } />
								<img src={ gmail } alt='GMail logo' className={ css(styleSheet.integration) } />
								<img src={ outlook } alt='Outlook logo' className={ css(styleSheet.integration) } />
								<img src={ hawksoft } alt='HawkSoft logo' className={ css(styleSheet.integration) } />
								<img src={ zillow } alt='Zillow logo' className={ css(styleSheet.integration) } />
								<img src={ realtorDotCom } alt='RealtorDotCom logo' className={ css(styleSheet.integration) } />
								<img src={ iHouseWeb } alt='iHouseWeb logo' className={ css(styleSheet.integration) } />
								<img src={ opcity } alt='OPCITY logo' className={ css(styleSheet.integration) } />
								<img src={ referralExchange } alt='Referral Exchange logo' className={ css(styleSheet.integration) } />
								<img src={ spacio } alt='SPACIO logo' className={ css(styleSheet.integration) } />
								<img src={ loopnet } alt='LoopNet logo' className={ css(styleSheet.integration) } />
							</div>
						</section>
					</main>
				</div>
			</div>
		);
	}

	private onChangeFirstName = (e: React.ChangeEvent<HTMLInputElement>) => { this.setState({ firstNameValue: e.currentTarget.value }); };
	private onChangeLastName = (e: React.ChangeEvent<HTMLInputElement>) => { this.setState({ lastNameValue: e.currentTarget.value }); };
	private onChangeCompany = (e: React.ChangeEvent<HTMLInputElement>) => { this.setState({ companyValue: e.currentTarget.value }); };
	private onChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => { this.setState({ emailValue: e.currentTarget.value }); };
	private onChangePhoneNumber = (e: React.ChangeEvent<HTMLInputElement>) => { this.setState({ phoneNumberValue: e.currentTarget.value }); };

	private onSubmitForDemo = () => {
		const { firstNameValue, lastNameValue, companyValue, emailValue, phoneNumberValue, utmSource } = this.state;

		if (!!firstNameValue && !!lastNameValue && !!companyValue && !!emailValue) {
			axios.post('https://api.levitate.ai/account/requestDemo', {
				company: companyValue,
				emailAddress: emailValue,
				firstName: firstNameValue,
				lastName: lastNameValue,
				phoneNumber: phoneNumberValue || '',
				source: utmSource || '',
			})
				.then(() => {
					this.setState({ demoRequested: 'success' });
				})
				.catch(() => {
					this.setState({ demoRequested: 'error' });
				});
		}
	}
}
